var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"stroke no-fill"},[_c('circle',{attrs:{"cx":"12.5","cy":"6.16","r":"5.02"}}),_c('path',{attrs:{"d":"M12.5,19.81v-8.64"}}),_c('path',{attrs:{"d":"M17.18,17.13c3.28.58,5.52,1.76,5.52,3.12,0,1.94-4.57,3.51-10.2,3.51s-10.2-1.57-10.2-3.51c0-1.39,2.35-2.6,5.77-3.17"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }